import { useEffect } from "react";

const useQueryParams = (
  selectedPersonas,
  selectedExpertiseLevels,
  setSelectedPersonas,
  setSelectedExpertiseLevels,
  hideCompletedCourses,
  setHideCompletedCourses
) => {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const urlPersonas = params.getAll("personas");
    const urlExpertiseLevels = params.getAll("expertiseLevels");
    const urlHideCompletedCourses = params.get("hide-completed-courses");

    if (JSON.stringify(urlPersonas) !== JSON.stringify(selectedPersonas)) {
      setSelectedPersonas(urlPersonas);
    }
    if (
      JSON.stringify(urlExpertiseLevels) !==
      JSON.stringify(selectedExpertiseLevels)
    ) {
      setSelectedExpertiseLevels(urlExpertiseLevels);
    }

    const newHideCompletedCourses = urlHideCompletedCourses === "true";

    if (newHideCompletedCourses !== hideCompletedCourses) {
      setHideCompletedCourses(newHideCompletedCourses);
    }
  }, [
    setSelectedPersonas,
    setSelectedExpertiseLevels,
    setHideCompletedCourses,
  ]);

  useEffect(() => {
    const currentPathname = window.location.pathname;
    const params = new URLSearchParams();

    selectedPersonas.forEach((persona) => {
      if (persona) {
        params.append("personas", persona);
      }
    });

    selectedExpertiseLevels.forEach((expertiseLevel) => {
      if (expertiseLevel) {
        params.append("expertiseLevels", expertiseLevel);
      }
    });

    if (hideCompletedCourses) {
      params.set("hide-completed-courses", "true");
    } else {
      params.delete("hide-completed-courses");
    }

    const newSearch = params.toString();
    const newUrl = `${currentPathname}${newSearch ? "?" + newSearch : ""}`;

    if (newSearch !== window.location.search.substring(1)) {
      window.history.replaceState({}, "", newUrl);
    }
  }, [selectedPersonas, selectedExpertiseLevels, hideCompletedCourses]);
};

export default useQueryParams;
